import { Auth0Provider } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { Else, If, Then } from 'react-if';
import { EffectContainer } from '../../../common/view/effect/effect-container';
import { AuthStateContext } from '../../core/user/auth.context';
import { DesktopApp } from './desktop-app';
import { CentralDragAndDrop } from './drag-and-drop/central-drag-and-drop';
import { MobileApp } from './mobile-app';

export function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <AuthStateContext.Provider>
      <Auth0Provider
        domain="auth.usemegaboard.com"
        clientId="9wwdZVay5MtWM89w667yuREpK4B4c6iv"
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
        cacheLocation="localstorage"
      >
        <CentralDragAndDrop>
          <EffectContainer>
            <If condition={windowWidth > 440}>
              <Then>
                <DesktopApp />
              </Then>
              <Else>
                <MobileApp />
              </Else>
            </If>
          </EffectContainer>
        </CentralDragAndDrop>
      </Auth0Provider>
    </AuthStateContext.Provider>
  );
}
